var _a, _b;
import { createSlice } from '@reduxjs/toolkit';
import { apiHolder, util, inWindow } from 'api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllAccountHK } from '@web-mail/util';
import { formatHotKey2Lib, formatHotKey2LibString } from '@web-common/utils/hotkey';
import { setStateToLocalStorage, getTreeStatesByAccount } from '@web-mail/util';
import { MAIL_TAG_HOTKEY_LOCAL_KEY } from '@web-mail/common/constant';
const dataStoreApi = apiHolder.api.getDataStoreApi();
const systemApi = apiHolder.api.getSystemApi();
const isElectron = apiHolder.env.forElectron;
const ReducerName = 'HotKeysReducer';
const GLOBAL_HOTKEYS_LOCAL_KEY = 'GLOBAL_HOTKEYS_LOCAL_KEY';
let AUTO_COMMAND_OR_CTRL = 'command';
let DEFAULT_CLIENT_MINIMIZE_LOCAL_KEY = ['ctrl', 'm'];
let DEFAULT_CLIENT_CAPTURESCREEN_LOCAL_KEY = ['alt', 'a'];
if (inWindow()) {
    AUTO_COMMAND_OR_CTRL = util.isMac() ? 'Command' : 'Ctrl';
    DEFAULT_CLIENT_MINIMIZE_LOCAL_KEY = util.isMac() ? [AUTO_COMMAND_OR_CTRL, 'm'] : [AUTO_COMMAND_OR_CTRL, 'shift', 'm'];
    DEFAULT_CLIENT_CAPTURESCREEN_LOCAL_KEY = util.isMac() ? [AUTO_COMMAND_OR_CTRL, 'shift', 'a'] : ['alt', 'a'];
}
export var HotKeysType;
(function (HotKeysType) {
    HotKeysType["CHAKANQUANBUKUAI"] = "CHAKANQUANBUKUAI";
    HotKeysType["ZUIXIAOHUA"] = "ZUIXIAOHUA";
    HotKeysType["QUANXUAN"] = "QUANXUAN";
    HotKeysType["FANGDATUPIAN"] = "FANGDATUPIAN";
    HotKeysType["FANGXIAOTUPIAN"] = "FANGXIAOTUPIAN";
    HotKeysType["BAOCUNTUPIAN"] = "BAOCUNTUPIAN";
    HotKeysType["DAKAISHEZHI"] = "DAKAISHEZHI";
    HotKeysType["DAKAIYOUXIANG"] = "DAKAIYOUXIANG";
    HotKeysType["DAKAIXIAOXI"] = "DAKAIXIAOXI";
    HotKeysType["DAKAIRILI"] = "DAKAIRILI";
    HotKeysType["DAKAIYUNWEN"] = "DAKAIYUNWEN";
    HotKeysType["DAKAITONGXUN"] = "DAKAITONGXUN";
    HotKeysType["DAKAIYINGXIAO"] = "DAKAIYINGXIAO";
    HotKeysType["DAKAIKEHU"] = "DAKAIKEHU";
    HotKeysType["YINCANG"] = "YINCANG";
    HotKeysType["MINMIZE"] = "MINMIZE";
    HotKeysType["CAPTURESCREEN"] = "CAPTURESCREEN";
    HotKeysType["SHANGYIFENGYOUJIAN"] = "SHANGYIFENGYOUJIAN";
    HotKeysType["XIAYIFENGYOUJIAN"] = "XIAYIFENGYOUJIAN";
    HotKeysType["DUXINSHANGYIF"] = "DUXINSHANGYIF";
    HotKeysType["DUXINXIAYIF"] = "DUXINXIAYIF";
    HotKeysType["HUIFU"] = "HUIFU";
    HotKeysType["HUIFUQUANBU"] = "HUIFUQUANBU";
    HotKeysType["ZHUANFA"] = "ZHUANFA";
    HotKeysType["BIAOJIYIDU"] = "BIAOJIYIDU";
    HotKeysType["BIAOJIWEIDU"] = "BIAOJIWEIDU";
    HotKeysType["DUOXUANYOUJIAN"] = "DUOXUANYOUJIAN";
    HotKeysType["SHANCHUYOUJIAN"] = "SHANCHUYOUJIAN";
    HotKeysType["XUANZHONGYOUJIANXIN"] = "XUANZHONGYOUJIANXIN";
    HotKeysType["FASONGYOUJIAN"] = "FASONGYOUJIAN";
    HotKeysType["LIANXUDUOXUANYOU"] = "LIANXUDUOXUANYOU";
    HotKeysType["SOUSUOYOUJIAN"] = "SOUSUOYOUJIAN";
    HotKeysType["XINJIANXIEXIN"] = "XINJIANXIEXIN";
    HotKeysType["BAOCUNCAOGAO"] = "BAOCUNCAOGAO";
    HotKeysType["DABIAOQIANQUXBQ"] = "DABIAOQIANQUXBQ";
    HotKeysType["FAXIAOXI"] = "FAXIAOXI";
    HotKeysType["SHANGYIFENGXIAOXI"] = "SHANGYIFENGXIAOXI";
    HotKeysType["XIAYIFENGXIAOXI"] = "XIAYIFENGXIAOXI";
    HotKeysType["HUANXING"] = "HUANXING";
    HotKeysType["KUAIJIESOUSUO"] = "KUAIJIESOUSUO";
    HotKeysType["DISKKUAIJIESOUSUO"] = "DISKKUAIJIESOUSUO";
})(HotKeysType || (HotKeysType = {}));
export const globalList = [
    {
        key: HotKeysType.CHAKANQUANBUKUAI,
        hotkey: [AUTO_COMMAND_OR_CTRL, '/'],
    },
    {
        key: HotKeysType.YINCANG,
        hotkey: [AUTO_COMMAND_OR_CTRL, 'w'],
        show: isElectron,
    },
    {
        key: HotKeysType.MINMIZE,
        hotkey: DEFAULT_CLIENT_MINIMIZE_LOCAL_KEY,
        show: isElectron,
    },
    {
        key: HotKeysType.CAPTURESCREEN,
        hotkey: DEFAULT_CLIENT_CAPTURESCREEN_LOCAL_KEY,
        show: isElectron,
    },
    {
        key: HotKeysType.FANGDATUPIAN,
        hotkey: [AUTO_COMMAND_OR_CTRL, '+'],
        show: isElectron,
    },
    {
        key: HotKeysType.FANGXIAOTUPIAN,
        hotkey: [AUTO_COMMAND_OR_CTRL, '-'],
        show: isElectron,
    },
    {
        key: HotKeysType.BAOCUNTUPIAN,
        hotkey: [AUTO_COMMAND_OR_CTRL, 's'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAISHEZHI,
        hotkey: [AUTO_COMMAND_OR_CTRL, '0'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAIYOUXIANG,
        hotkey: [AUTO_COMMAND_OR_CTRL, '1'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAIXIAOXI,
        hotkey: [AUTO_COMMAND_OR_CTRL, '2'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAIRILI,
        hotkey: [AUTO_COMMAND_OR_CTRL, '3'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAIYUNWEN,
        hotkey: [AUTO_COMMAND_OR_CTRL, '4'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAITONGXUN,
        hotkey: [AUTO_COMMAND_OR_CTRL, '5'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAIYINGXIAO,
        hotkey: [AUTO_COMMAND_OR_CTRL, '6'],
        show: isElectron,
    },
    {
        key: HotKeysType.DAKAIKEHU,
        hotkey: [AUTO_COMMAND_OR_CTRL, '7'],
        show: isElectron,
    },
];
export const mailHotKeys = [
    {
        key: HotKeysType.SOUSUOYOUJIAN,
        hotkey: [AUTO_COMMAND_OR_CTRL, 'f'],
    },
    {
        key: HotKeysType.XINJIANXIEXIN,
        hotkey: ['shift', 'c'],
    },
    {
        key: HotKeysType.BAOCUNCAOGAO,
        hotkey: [AUTO_COMMAND_OR_CTRL, 's'],
    },
    {
        key: HotKeysType.SHANGYIFENGYOUJIAN,
        hotkey: 'up',
    },
    {
        key: HotKeysType.XIAYIFENGYOUJIAN,
        hotkey: 'down',
    },
    {
        key: HotKeysType.SHANCHUYOUJIAN,
        hotkey: ['ctrl', 'd'],
    },
    {
        key: HotKeysType.DUXINSHANGYIF,
        hotkey: '[',
    },
    {
        key: HotKeysType.DUXINXIAYIF,
        hotkey: ']',
    },
    {
        key: HotKeysType.HUIFU,
        hotkey: ['shift', 'r'],
    },
    {
        key: HotKeysType.HUIFUQUANBU,
        hotkey: ['shift', 'a'],
    },
    {
        key: HotKeysType.ZHUANFA,
        hotkey: ['shift', 'f'],
    },
    {
        key: HotKeysType.BIAOJIYIDU,
        hotkey: ['shift', 'i'],
    },
    {
        key: HotKeysType.BIAOJIWEIDU,
        hotkey: ['shift', 'u'],
    },
    {
        key: HotKeysType.XUANZHONGYOUJIANXIN,
        hotkey: [AUTO_COMMAND_OR_CTRL, 'r'],
    },
    {
        key: HotKeysType.FASONGYOUJIAN,
        hotkey: [AUTO_COMMAND_OR_CTRL, 'enter'],
    },
];
export const getAllDefaultHotKeysMap = () => {
    const map = {};
    globalList.forEach(item => {
        map[item.key] = item.hotkey;
    });
    mailHotKeys.forEach(item => {
        map[item.key] = item.hotkey;
    });
    return map;
};
let InitialState = {
    globalHotKeysMap: {},
    mailHotKeysMap: {},
    mailTagHotKeysMap: {},
};
const getMapFromList = (list, map) => {
    if (list) {
        list.forEach(item => {
            if (item.show || item.show === undefined) {
                map[item === null || item === void 0 ? void 0 : item.key] = item === null || item === void 0 ? void 0 : item.hotkey;
            }
        });
    }
};
try {
    getMapFromList(globalList, InitialState.globalHotKeysMap);
    getMapFromList(mailHotKeys, InitialState.mailHotKeysMap);
}
catch (e) {
    console.error('[HotKeysReducer] init error', e);
}
try {
    if (inWindow()) {
        const localDataStr = localStorage.getItem(GLOBAL_HOTKEYS_LOCAL_KEY);
        if (localDataStr) {
            const localData = JSON.parse(localDataStr);
            if (localData && typeof localData === 'object') {
                for (let i in InitialState) {
                    const moduleData = InitialState[i];
                    if (moduleData) {
                        for (let n in moduleData) {
                            if (localData[n]) {
                                InitialState[i][n] = localData[n];
                            }
                        }
                    }
                }
            }
        }
        const allAccountMap = getAllAccountHK();
        if (allAccountMap) {
            InitialState.mailTagHotKeysMap = allAccountMap;
        }
    }
}
catch (e) {
    console.error('[HotKeysReducer] init error', e);
}
const oldKeyStrMap = {
    '⌘': 'command',
    Ctrl: 'ctrl',
    Shift: 'shift',
    '↵': 'enter',
    '↑': 'up',
    '↓': 'down',
    CommandOrControl: AUTO_COMMAND_OR_CTRL,
};
const transOldHk2NewHk = (oldhk) => {
    if (oldhk) {
        const oldhkArr = oldhk.trim().replace(/\s+/g, ' ').split(' ');
        if (oldhkArr && oldhkArr.length) {
            const newhkArr = oldhkArr.map(item => {
                return oldKeyStrMap[item] || item.toLowerCase();
            });
            return newhkArr;
        }
    }
    return null;
};
try {
    if (isElectron) {
        const storeShortcut = (_a = dataStoreApi.getSync('captureScreenShortcut')) === null || _a === void 0 ? void 0 : _a.data;
        const miniShortcut = (_b = dataStoreApi.getSync('minimizeShortcut')) === null || _b === void 0 ? void 0 : _b.data;
        if (storeShortcut) {
            const keys = transOldHk2NewHk(storeShortcut);
            if (keys && keys.length) {
                InitialState.globalHotKeysMap[HotKeysType.CAPTURESCREEN] = keys;
                dataStoreApi.del('captureScreenShortcut');
            }
        }
        if (miniShortcut) {
            const keys = transOldHk2NewHk(miniShortcut);
            if (keys && keys.length) {
                InitialState.globalHotKeysMap[HotKeysType.MINMIZE] = keys;
                dataStoreApi.del('minimizeShortcut');
            }
        }
    }
}
catch (e) {
    console.error('[HotKeysReducer] old Data transError ', e);
}
try {
    if (isElectron) {
        try {
            apiHolder.api.getSystemApi().setMinimizeGlobalShortcutUI({
                oldShortcut: formatHotKey2LibString(InitialState.globalHotKeysMap[HotKeysType.MINMIZE]),
                newShortcut: formatHotKey2LibString(InitialState.globalHotKeysMap[HotKeysType.MINMIZE]),
            });
        }
        catch (e) {
            console.error('[HotKeysReducer] init error setMinimizeGlobalShortcutUI', e);
        }
        try {
            apiHolder.api.getSystemApi().setScreenCaptureShortcut({
                oldShortcut: formatHotKey2LibString(InitialState.globalHotKeysMap[HotKeysType.CAPTURESCREEN]),
                newShortcut: formatHotKey2LibString(InitialState.globalHotKeysMap[HotKeysType.CAPTURESCREEN]),
            });
        }
        catch (e) {
            console.error('[HotKeysReducer] setScreenCaptureShortcut error ', e);
        }
    }
}
catch (e) {
    console.error('[HotKeysReducer] init error', e);
}
const getGlobalHotKeysMapFromRedux = (state) => {
    const globalMap = {};
    if (state) {
        for (let i in state.globalHotKeysMap) {
            let key = i;
            const data = state.globalHotKeysMap[key];
            if (data) {
                const res = formatHotKey2Lib(data);
                if (Array.isArray(res)) {
                    res.forEach(item => {
                        if (item) {
                            globalMap[item] = true;
                        }
                    });
                }
                else {
                    if (res) {
                        globalMap[res] = true;
                    }
                }
            }
        }
        for (let i in state.mailHotKeysMap) {
            let key = i;
            const data = state.mailHotKeysMap[key];
            if (data) {
                const res = formatHotKey2Lib(data);
                if (Array.isArray(res)) {
                    res.forEach(item => {
                        if (item) {
                            globalMap[item] = true;
                        }
                    });
                }
                else {
                    if (res) {
                        globalMap[res] = true;
                    }
                }
            }
        }
        for (let i in state.mailTagHotKeysMap) {
            const accountData = state.mailTagHotKeysMap[i];
            if (accountData) {
                for (let tagName in accountData) {
                    const res = formatHotKey2Lib(accountData[tagName]);
                    if (Array.isArray(res)) {
                        res.forEach(item => {
                            if (item) {
                                globalMap[item] = true;
                            }
                        });
                    }
                    else {
                        if (res) {
                            globalMap[res] = true;
                        }
                    }
                }
            }
        }
    }
    return globalMap;
};
const getGlobalHKkVMapFromRedux = (state) => {
    const globalMap = {};
    for (let i in state.globalHotKeysMap) {
        let key = i;
        const data = state.globalHotKeysMap[key];
        globalMap[i] = data;
    }
    for (let i in state.mailHotKeysMap) {
        let key = i;
        const data = state.mailHotKeysMap[key];
        globalMap[i] = data;
    }
    return globalMap;
};
const validateHotKeys = (hotkey, globalMap) => {
    const diffStr = formatHotKey2Lib(hotkey);
    if (Array.isArray(diffStr)) {
        const res = formatHotKey2Lib(diffStr[0]);
        return !globalMap[res];
    }
    else {
        const res = formatHotKey2Lib(diffStr);
        return !globalMap[res];
    }
};
export const validateGlobalHK = createAsyncThunk(`hotkeysReucer/validateGlobalHK`, (hotkey, thunkAPI) => {
    const state = thunkAPI.getState().hotKeyReducer;
    const globalMap = getGlobalHotKeysMapFromRedux(state);
    return validateHotKeys(hotkey, globalMap) ? Promise.resolve(true) : Promise.reject(false);
});
export const validateMailHK = createAsyncThunk(`hotkeysReucer/validateMailHK`, (hotkey, thunkAPI) => {
    const state = thunkAPI.getState().hotKeyReducer;
    const globalMap = {};
    for (let i in state.globalHotKeysMap) {
        const data = state.globalHotKeysMap[i];
        if (data) {
            const str = formatHotKey2Lib(data);
            if (str) {
                globalMap[str] = true;
            }
        }
    }
    for (let i in state.mailHotKeysMap) {
        const data = state.mailHotKeysMap[i];
        if (data) {
            const str = formatHotKey2Lib(data);
            if (str) {
                globalMap[str] = true;
            }
        }
    }
    for (let i in state.mailTagHotKeysMap) {
        const accountData = state.mailTagHotKeysMap[i];
        if (accountData) {
            for (let tagName in accountData) {
                const str = formatHotKey2Lib(accountData[tagName]);
                if (str) {
                    globalMap[str] = true;
                }
            }
        }
    }
    return !globalMap[formatHotKey2Lib(hotkey)] ? Promise.resolve(true) : Promise.reject(false);
});
export const validateMailTagHK = createAsyncThunk(`hotkeysReucer/validateMailTagHK`, (params, thunkAPI) => {
    var _a;
    const { hotkey, account } = params;
    const state = thunkAPI.getState().hotKeyReducer;
    const mailState = thunkAPI.getState().mailReducer;
    const accountKey = ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id) || account || 'main';
    const globalMap = {};
    for (let i in state.globalHotKeysMap) {
        const data = state.globalHotKeysMap[i];
        if (data) {
            const str = formatHotKey2Lib(data);
            if (str) {
                globalMap[str] = true;
            }
        }
    }
    for (let i in state.mailHotKeysMap) {
        const data = state.mailHotKeysMap[i];
        if (data) {
            const str = formatHotKey2Lib(data);
            if (str) {
                globalMap[str] = true;
            }
        }
    }
    const deleteTag = [];
    for (let tagName in state.mailTagHotKeysMap[accountKey]) {
        const str = formatHotKey2Lib(state.mailTagHotKeysMap[accountKey][tagName]);
        try {
            const mailTreeStateMap = mailState.mailTreeStateMap;
            const folderState = getTreeStatesByAccount(mailTreeStateMap, accountKey || '');
            const mailTagList = (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList) || [];
            const tag = mailTagList.find(item => item[0] === tagName);
            if (!tag) {
                deleteTag.push(tagName);
                continue;
            }
        }
        catch (e) {
            console.error(e);
        }
        if (str) {
            globalMap[str] = true;
        }
    }
    try {
        if (deleteTag === null || deleteTag === void 0 ? void 0 : deleteTag.length) {
            let map = Object.assign({}, state.mailTagHotKeysMap);
            map[accountKey] = Object.assign({}, map[accountKey]);
            deleteTag.forEach(item => {
                if (map[accountKey][item]) {
                    delete map[accountKey][item];
                }
            });
            thunkAPI.dispatch(mailSlice.actions.doReplaceMailTagHotKey({
                hotkeysMap: map,
                account: accountKey,
            }));
        }
    }
    catch (e) {
        console.error(e);
    }
    return !globalMap[formatHotKey2Lib(hotkey)] ? Promise.resolve(true) : Promise.reject(false);
});
const mailSlice = createSlice({
    name: ReducerName,
    initialState: InitialState,
    reducers: {
        doUpdateHotKeysMap: (state, action) => {
            var _a, _b;
            const { key, value } = action.payload;
            if (key === HotKeysType.MINMIZE) {
                try {
                    if (isElectron) {
                        apiHolder.api.getSystemApi().setMinimizeGlobalShortcutUI({
                            oldShortcut: formatHotKey2LibString(state.globalHotKeysMap[key]),
                            newShortcut: formatHotKey2LibString(value),
                        });
                    }
                }
                catch (e) {
                    console.error('[HotKeysReducer] update error 2', e);
                }
            }
            if (key === HotKeysType.CAPTURESCREEN) {
                try {
                    if (isElectron) {
                        apiHolder.api.getSystemApi().setScreenCaptureShortcut({
                            oldShortcut: formatHotKey2LibString(state.globalHotKeysMap[key]),
                            newShortcut: formatHotKey2LibString(value),
                        });
                    }
                }
                catch (e) {
                    console.error('[HotKeysReducer] update error 2', e);
                }
            }
            if (globalList.find(item => item.key === key)) {
                let res = Object.assign({}, state.globalHotKeysMap);
                res[key] = value;
                state.globalHotKeysMap = res;
            }
            if (mailHotKeys.find(item => item.key === key)) {
                let res = Object.assign({}, state.mailHotKeysMap);
                res[key] = value;
                state.mailHotKeysMap = res;
            }
            try {
                const diffMap = {};
                const defaultHkMap = getAllDefaultHotKeysMap();
                const curHkMap = getGlobalHKkVMapFromRedux(state);
                for (let i in curHkMap) {
                    const htKey = i;
                    if (defaultHkMap[htKey]) {
                        try {
                            const diff = ((_a = JSON.stringify(defaultHkMap[htKey])) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== ((_b = JSON.stringify(curHkMap[htKey])) === null || _b === void 0 ? void 0 : _b.toLowerCase());
                            if (diff) {
                                diffMap[htKey] = curHkMap[htKey];
                            }
                        }
                        catch (e) {
                            console.error('[HotKeysReducer] update error 0', e);
                        }
                    }
                }
                localStorage.setItem(GLOBAL_HOTKEYS_LOCAL_KEY, JSON.stringify(diffMap));
            }
            catch (e) {
                console.error('[HotKeysReducer] update error 1', e);
            }
        },
        doAddMailTagHotKey: (state, action) => {
            var _a;
            const { name, hotkey, account } = action.payload;
            try {
                const accountKey = ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id) || account || 'main';
                if (state.mailTagHotKeysMap[accountKey]) {
                    let res = Object.assign({}, state.mailTagHotKeysMap[accountKey]);
                    if (hotkey && hotkey.length > 0) {
                        res[name] = hotkey;
                    }
                    else {
                        try {
                            delete res[name];
                        }
                        catch (e) {
                            console.error('[TagHotKeysReducer] update error', e);
                        }
                    }
                    state.mailTagHotKeysMap[accountKey] = res;
                    state.mailTagHotKeysMap = Object.assign({}, state.mailTagHotKeysMap);
                }
                else {
                    if (hotkey && hotkey.length > 0) {
                        state.mailTagHotKeysMap[accountKey] = {
                            [name]: hotkey,
                        };
                        state.mailTagHotKeysMap = Object.assign({}, state.mailTagHotKeysMap);
                    }
                }
                setStateToLocalStorage(MAIL_TAG_HOTKEY_LOCAL_KEY, state.mailTagHotKeysMap);
            }
            catch (e) {
                console.error('[TagHotKeysReducer] update error', e);
            }
        },
        doUpdateMailTagHotKey: (state, action) => {
            var _a;
            const { oldName, name, hotkey, account } = action.payload;
            try {
                const accountKey = ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id) || account || 'main';
                if (state.mailTagHotKeysMap[accountKey]) {
                    let res = Object.assign({}, state.mailTagHotKeysMap[accountKey]);
                    if (oldName) {
                        try {
                            delete res[oldName];
                        }
                        catch (e) {
                            console.error('[TagHotKeysReducer] update error', e);
                        }
                    }
                    if (hotkey && hotkey.length > 0) {
                        res[name] = hotkey;
                    }
                    else {
                        try {
                            delete res[name];
                        }
                        catch (e) {
                            console.error('[TagHotKeysReducer] update error', e);
                        }
                    }
                    state.mailTagHotKeysMap[accountKey] = res;
                    state.mailTagHotKeysMap = Object.assign({}, state.mailTagHotKeysMap);
                }
                else {
                    if (hotkey) {
                        state.mailTagHotKeysMap[accountKey] = {
                            [name]: hotkey,
                        };
                        state.mailTagHotKeysMap = Object.assign({}, state.mailTagHotKeysMap);
                    }
                }
                setStateToLocalStorage(MAIL_TAG_HOTKEY_LOCAL_KEY, state.mailTagHotKeysMap);
            }
            catch (e) {
                console.error('[TagHotKeysReducer] update error', e);
            }
        },
        doReplaceMailTagHotKey: (state, action) => {
            const { hotkeysMap, account } = action.payload;
            try {
                const accountKey = account;
                if (hotkeysMap) {
                    state.mailTagHotKeysMap = Object.assign({}, hotkeysMap);
                }
                setStateToLocalStorage(MAIL_TAG_HOTKEY_LOCAL_KEY, state.mailTagHotKeysMap);
            }
            catch (e) {
                console.error('[TagHotKeysReducer] replace error', e);
            }
        },
    },
});
export const { actions } = mailSlice;
export default mailSlice.reducer;
